<div [class.progress-spinner-wrapper--overlay]="overlay" [class.progress-spinner-wrapper]="!overlay">
  <mat-progress-spinner [color]="spinnerColor" mode="indeterminate" [diameter]="spinnerSize"></mat-progress-spinner>
  <h3 *ngIf="spinnerText">{{ spinnerText }}</h3>
</div>
